/* eslint-disable no-param-reassign, no-shadow */
angular
  .module('resyApp')
  .directive('resyToggleActive', resyToggleActive);

function resyToggleActive() {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      const clickTarget = attrs.resyToggleActive;
      scope.isActive = element.hasClass('active');

      element.find(clickTarget).on('click', () => {
        if (scope.isActive) {
          element.removeClass('active');
        } else {
          element.addClass('active');
        }
        scope.$apply((scope) => {
          scope.isActive = !scope.isActive;
        });
      });
    },
  };
}

export default () => {};
